var map = {
	"./huawei-appgallery-badge-ca.png": "LSxh",
	"./huawei-appgallery-badge-en.png": "vYuf",
	"./huawei-appgallery-badge-es.png": "Oar2",
	"./huawei-appgallery-badge-pt.png": "r7EW"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "obX2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img ^\.\/huawei\-appgallery\-badge\-.*\.png$
// module id = obX2
// module chunks = 1